import { WellboreDataIntermittenceDTO } from 'types/dataIntermittenceDto';
import { WellboreOutlierDTO } from 'types/outlierDto';

import { MnemonicsRatioData } from '../pages/DataManagementDataQuality/components/ClosedRow/utils/mnemonicsRatioData';
import { computeDataQualityIndex } from '../pages/DataManagementDataQuality/components/DataQualityIndex/computeDataQualityIndex';

export const computeDataQualityLight = ({
  outlier,
  dataIntermittence,
  mnemonicsRatioData,
  dataConsistencyIndex,
}: {
  dataConsistencyIndex: number;
  outlier?: WellboreOutlierDTO;
  mnemonicsRatioData: MnemonicsRatioData;
  dataIntermittence?: WellboreDataIntermittenceDTO;
}) => {
  const dataQualityIndex = computeDataQualityIndex(
    mnemonicsRatioData,
    dataConsistencyIndex,
    outlier,
    dataIntermittence,
  );
  const isGreenOn = dataQualityIndex > 0.8;
  const isRedOn = dataQualityIndex <= 0.5;
  const isOrangeOn = !isGreenOn && !isRedOn;

  return { dataQualityIndex, isGreenOn, isOrangeOn, isRedOn };
};
